module.exports = __webpack_public_path__ + "static/soucie_horner-f32c926cca0ffd91f70b52a5327fb5bf.jpg";